import { jsx as _jsx } from "react/jsx-runtime";
import { DayPicker } from 'react-day-picker';
import { parseDateToSimpleFormat, formatWeekdayName } from './utils';
import 'react-day-picker/src/style.css';
import './styles-datepicker.scss';
export var DatepickerBase = function (_a) {
    var onSelectDate = _a.onSelectDate, value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, dateFormat = _a.dateFormat;
    return (_jsx(DayPicker, { animate: true, mode: "single", selected: new Date(value), onSelect: function (selectedDay) { return onSelectDate(parseDateToSimpleFormat(selectedDay, dateFormat)); }, showOutsideDays: true, ISOWeek: true, disabled: [{ before: minDate }, { after: maxDate }].filter(Boolean), startMonth: minDate, endMonth: maxDate, formatters: {
            formatWeekdayName: formatWeekdayName,
        }, fixedWeeks: true }));
};
